import React, { useState, useEffect } from "react";
import axios from "axios";
import "./../../styles/admin/clientes.css";
import * as globals from "./../../components/GlobalScripts.js";
import { useNavigate } from "react-router-dom";

const Admin_clientes = () => {
    let path_api = localStorage.getItem("path_api");
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [clientes, setClientes] = useState([]);
    const [selectedClientes, setSelectedClientes] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        getClientes();
    }, [search, currentPage]);

    const getClientes = () => {
        globals.validateSession();
        axios
            .post(`${path_api}/admin/clientes.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                page: currentPage,
                search: search,
                limit: 10,
            })
            .then((response) => {
                if (response.data.mensaje === "success") {
                    setClientes(response.data.clientes);
                    setTotalPages(response.data.total_pages);
                    setSelectedClientes([]);
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "No se obtuvieron los clientes",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
            })
            .catch(() => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "Error al cargar los clientes",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
            });
    };

    const changePage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleRowClick = (keylogin) => {
        navigate(`/admin/clientes/${keylogin}`);
    };

    const handleSelectCliente = (keylogin) => {
        if (selectedClientes.includes(keylogin)) {
            setSelectedClientes((prev) => prev.filter((k) => k !== keylogin));
        } else {
            setSelectedClientes((prev) => [...prev, keylogin]);
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allKeylogins = clientes.map((c) => c.keylogin);
            setSelectedClientes(allKeylogins);
        } else {
            setSelectedClientes([]);
        }
    };

    const deleteSelected = async () => {
        if (selectedClientes.length === 0) {
            globals.createAlert({
                type: "info",
                msg_title: "Info",
                msg: "No hay clientes seleccionados para eliminar",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000,
            });
            return;
        }

        globals.validateSession();
        globals.openViewCharge();
        await axios
            .post(`${path_api}/admin/delete_clientes.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                keys: selectedClientes,
            })
            .then((response) => {
                if (response.data.mensaje === "success") {
                    globals.createAlert({
                        type: "success",
                        msg_title: "Éxito",
                        msg: "Clientes eliminados correctamente",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                    getClientes();
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Error al eliminar clientes",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
            })
            .catch(() => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "Error al eliminar clientes",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
            })
            .finally(() => globals.closeViewCharge());
    };

    return (
        <>
            <h2>Listado de clientes</h2>

            <div className="container-nav-search">
                <div>
                    <label>Filtrar</label>
                    <input
                        type="text"
                        placeholder="Escribe para filtrar por nombre, email o rol"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <button onClick={() => navigate(`/admin/clientes/new`)}>
                    Agregar Cliente
                </button>
                {selectedClientes.length > 0 && (
                    <button onClick={deleteSelected} className="delete-button">
                        Eliminar ({selectedClientes.length})
                    </button>
                )}
            </div>

            <div className="container-table clientes">
                <table>
                    <thead>
                        <tr>
                            <th style={{ maxWidth: "40px" }}>
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={
                                        selectedClientes.length ===
                                            clientes.length &&
                                        clientes.length > 0
                                    }
                                />
                            </th>
                            <th>Email</th>
                            <th>Nombre</th>
                            <th style={{ maxWidth: "50px" }}>Rol</th>
                            <th style={{ maxWidth: "150px" }}>Fecha de Creación</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clientes.map((cliente) => {
                            const isSelected =
                                selectedClientes.includes(cliente.keylogin);
                            return (
                                <tr key={cliente.keylogin}>
                                    <td style={{ maxWidth: "40px" }}>
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() =>
                                                handleSelectCliente(
                                                    cliente.keylogin
                                                )
                                            }
                                        />
                                    </td>
                                    <td
                                        onClick={() =>
                                            handleRowClick(cliente.keylogin)
                                        }
                                    >
                                        {cliente.email}
                                    </td>
                                    <td
                                        onClick={() =>
                                            handleRowClick(cliente.keylogin)
                                        }
                                    >
                                        {cliente.nombre}
                                    </td>
                                    <td  style={{ maxWidth: "50px" }}
                                        onClick={() =>
                                            handleRowClick(cliente.keylogin)
                                        }
                                    >
                                        {cliente.rol}
                                    </td>
                                    <td  style={{ maxWidth: "150px" }}
                                        onClick={() =>
                                            handleRowClick(cliente.keylogin)
                                        }
                                    >
                                        {cliente.createAt}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <div className="pagination">
                    <div>
                        <span>Mostrando <b>{clientes.length}</b> clientes</span>
                    </div>
                    <div>
                        <button
                            onClick={() => changePage(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            Anterior
                        </button>
                        <span>
                            Página <b>{currentPage}</b> de <b>{totalPages}</b>
                        </span>
                        <button
                            onClick={() => changePage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Admin_clientes;
